// src/hooks/useSearchStats.js
import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

export default function useSearchStats(initial = {}) {
    const [items, setItems] = useState([]);
    const [total, setTotal] = useState(0);
    const [limit, setLimit] = useState(initial.limit || 50);
    const [offset, setOffset] = useState(initial.offset || 0);
    const [q, setQ] = useState(initial.q || "");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchStats = useCallback(async (opts = {}) => {
        setLoading(true);
        setError("");
        try {
            const params = new URLSearchParams();
            params.set("limit", String(opts.limit ?? limit));
            params.set("offset", String(opts.offset ?? offset));
            if ((opts.q ?? q)?.trim()) params.set("q", (opts.q ?? q).trim());

            const res = await axios.get(`${API_BASE}/api/stats/search?` + params.toString(), { timeout: 15000 });
            const data = res.data || {};
            setItems(Array.isArray(data.items) ? data.items : []);
            setTotal(Number(data.total || 0));
            if (opts.limit != null) setLimit(opts.limit);
            if (opts.offset != null) setOffset(opts.offset);
            if (opts.q != null) setQ(opts.q);
        } catch (e) {
            console.error(e);
            setError(e?.response?.data?.error || e?.message || "Konnte Statistiken nicht laden.");
            setItems([]);
        } finally {
            setLoading(false);
        }
    }, [limit, offset, q]);

    useEffect(() => {
        fetchStats({});
    }, []); // nur initial

    return {
        items, total, limit, offset, q,
        setLimit, setOffset, setQ,
        loading, error, fetchStats
    };
}
